import React from "react";
import { PiBell } from "react-icons/pi";
import cn from "../../lib/cn";

const NotificationBell = ({ isVisible, onOpen }) => {
    return (
        <div
            className="border border-[#1E354D] rounded-full  w-[35px] h-[35px]
         sm:w-[40px] 
         sm:h-[40px] xl:w-[40px]
           xl:h-[40px] flex justify-center mr-1"
        >
            <button
                className={cn("", {
                    "text-primary": isVisible,
                    "text-white": !isVisible,
                })}
                onClick={onOpen}
            >
                <PiBell size={26} />
            </button>
        </div>
    );
};

export default NotificationBell;
